<template>
  <div class="private_container">
    <div class="private_box">
      <div class="title_box">
        <div class="h2"><span>极目新闻客户端及网站隐私政策</span></div>
        <div class="h3"><span>本政策包含以下内容：</span></div>
        <div class="h4"><span>一、我们收集哪些信息</span></div>
        <div class="h4"><span>二、如何使用您的个人信息</span></div>
        <div class="h4"><span>三、我们如何存储、共享、转让、转移、披露您的个人信息</span></div>
        <div class="h4">
          <span>四、我们如何使用</span><span class="en"> Cookie </span><span>和同类技术</span>
        </div>
        <div class="h4"><span>五、您的权利</span></div>
        <div class="h4"><span>六、我们如何保护您的个人信息</span></div>
        <div class="h4"><span>七、未成年人个人信息的保护</span></div>
        <div class="h4"><span>八、本政策如何更新</span></div>
        <div class="h4"><span>九、如何联系我们</span></div>
      </div>
      <div class="content_box">
        <div class="block_box">
          <p>
            <span>极目新闻客户端及网站（以下简称</span><span class="quotation">“</span><span>极目新闻</span><span class="quotation">”</span><span>）深知个人信息对您的重要性，并会尽全力保护您对自身的个人信息的安全可控。极目新闻承诺，我们将按业界通行的安全标准，采取相应的安全保护措施来保护您的个人信息。</span>
          </p>
          <p>
            <span>极目新闻开发者</span><span class="quotation"> “ </span><span>湖北楚天都市报传媒有限责任公司</span><span class="quotation"> ” </span><span>，为</span><span class="quotation"> “ </span><span>湖北日报传媒集团</span><span class="quotation"> ” </span><span>旗下的独立法人企业，是楚天都市报全媒体平台所有经营业务的运营机构，</span><span class="quotation"> “ </span><span>湖北日报传媒集团</span><span class="quotation"> ” </span><span>是湖北网信办授权的互联网新闻信息服务单位。如您对本《隐私政策》或与本《隐私政策》相关的事宜有任何问题，请通过027-86777777与我们联系。</span>
          </p>
          <p>
            <span>请在向极目新闻提交个人信息前，阅读、了解并同意本《隐私政策》。</span>
          </p>
        </div>
        <div class="h4">
          <span>一、我们收集哪些信息</span>
        </div>
        <div class="block_box">
          <p>
            <span>根据《中华人民共和国网络安全法》，个人信息是指</span><span class="quotation">“</span><span>以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，包括但不限于自然人的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码等</span><span class="quotation">”</span><span>。</span>
          </p>
          <p>
            <span>当您在极目新闻上创建账户时，您向我们提供您的全名和手机号或社交账号。如果您不想提供您的真实姓名，可以使用化名。</span>
          </p>
          <p>
            <span>为了保障软件与服务的安全运行，我们可能还会在您使用极目新闻及网站之时收集您的操作系统版本号、移动设备识别码、唯一设备标识符（IMEI/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI信息）、网络设备硬件地址(MAC地址)、IP地址、WLAN接入点、蓝牙、基站、软件版本号、网络接入方式、类型、状态、网络自量数据、操作、使用、服务日志。</span>
          </p>
          <p>
            <span>为了预防恶意程序及安全运营所必需，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。</span>
          </p>
          <p>
            <span>我们可能会获取您使用极目新闻时的浏览记录，这些信息可能包括以下数据：您的收藏、评论、转发、点赞、发布、举报等主动操作的日志记录，浏览、搜索、点击等操作记录。</span>
          </p>
          <p>
            <span>您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。</span>
          </p>
          <p>
            <span>设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码；</span>
          </p>
          <p>
            <span>您使用上传图片、视频功能时，我们会请求您授权相机、照片、麦克风权限。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用极目新闻的其他功能。</span>
          </p>
          <p>
            <span>您在使用我们服务时搜索和浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；</span>
          </p>
          <p>
            <span>您使用本APP的闹钟服务功能时，为了保证在您设定的时间准时提醒您，我们需要使用自启动服务以便闹钟提醒能正常提醒，如您想关掉自启动功能，可能会导致无法正常提醒。您可以在设置-应用-自启动管理中关闭自启动功能。</span>
          </p>
          <p>
            <span>您使用本APP的推送服务功能时，为了保证我们及时将最新新闻推送给您，我们需要使用自启动服务以便推送服务能正常使用，如您想关掉自启动功能，可能会导致无法正常推送。您可以在设置-应用-自启动管理中关闭自启动功能。</span>
          </p>
          <p>
            <span>您使用直播查看、视频查看、广告查看的横竖屏切换功能时屏幕亮度自动调节功能时，我们将访问您提供的设备的加速度传感器、距离传感器数据,以识别您的设备横竖屏状态,适配您的机型展示。</span>
          </p>
          <p>
            <span>位置信息指您开启设备定位功能并使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，包括：您通过具有定位功能的移动设备使用我们的服务时，我们通过GPS或WiFi等方式收集的您的地理位置信息；您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，例如您或其他人共享的照片包含的地理标记信息；您可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。</span>
          </p>
          <p>
            <span>我们在后台状态会申请系统设备权限收集设备信息、用户IMSI信息，用于为您推送新闻、确保服务的稳定性等。</span>
          </p>
          <p>
            <strong><span>请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。</span></strong>
          </p>
          <p>
            <span>您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息。</span>
          </p>
        </div>
        <div class="h4">
          <span>二、如何使用您的个人信息</span>
        </div>
        <div class="block_box">
          <p>
            <span>极目新闻仅会出于本政策所述的以下目的，收集和使用您的个人信息：</span>
          </p>
          <ul>
            <!-- <li>
              <p>
                <span>向您提供个性化推荐展示需要；</span>
              </p>
            </li> -->
            <!-- <li>
              <p>
                <span>向您提供推送关注的新闻资讯，您可随时关闭定向推送功能；</span>
              </p>
            </li> -->
            <li>
              <p>
                <span>保障网络安全和处理用户纠纷；</span>
              </p>
            </li>
            <li>
              <p>
                <span>在我们提供服务时，用于身份验证、客户服务、确保我们向您提供的产品和服务的安全性；</span>
              </p>
            </li>
            <li>
              <p>
                <span>帮助我们改善我们现有服务；</span>
              </p>
            </li>
            <li>
              <p>
                <span>向您提供与您更加相关的广告以替代普遍投放的广告；</span>
              </p>
            </li>
            <li>
              <p>
                <span>评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；</span>
              </p>
            </li>
            <li>
              <p>
                <span>让您参与有关我们产品和服务的调查</span>
              </p>
            </li>
          </ul>
          <p>
            <span>当我们要将信息用于本隐私权政策未载明的其它用途时，会事先征求您的同意。</span>
          </p>
          <p>
            <span>当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</span>
          </p>
          <p>
            <span>我们可能使用您的账户信息、设备信息、服务日志信息以及我们关联公司、合作方在获得您授权或依法可以共享的信息，用于判断账号安全、进行身份验证、检测及防范安全事件。</span>
          </p>
        </div>
        <div class="h4">
          <span>三、我们如何存储、共享、转让、披露您的个人信息</span>
        </div>
        <div class="block_box">
          <p style="text-align:left;text-indent:0;">
            <strong><span>（一）存储</span></strong>
          </p>
          <p>
            <span>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（二）共享</span></strong>
          </p>
          <p>
            <span>我们不会与极目新闻（湖北楚天都市报传媒有限责任公司）以外的任何公司、组织和个人分享您的个人信息，但您同意以下情况除外：</span>
          </p>
          <p>
            <span class="quotation">1.</span><span>在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</span>
          </p>
          <p>
            <span class="quotation">2.</span><span>与授权合作伙伴共享：仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人数据，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（三）转让</span></strong>
          </p>
          <p>
            <span>我们不会将您的个人信息转让给任何公司、组织和个人，但满足以下条件的情形除外：</span>
          </p>
          <p>
            <span class="quotation">1.</span><span>在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</span>
          </p>
          <p>
            <span class="quotation">2.</span><span>如果涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在任何个人信息进行转让或受其他隐私政策约束之前，确保通知受到影响的用户，并要求获得您个人信息的第三方重新向您征求授权同意。</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（四）转移</span></strong>
          </p>
          <p>
            <span>您的个人信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（五）披露</span></strong>
          </p>
          <p>
            <span>本着诚信原则，我们仅会在以下情况下，披露您的个人信息：</span>
          </p>
          <p>
            <span class="quotation">1.</span><span>基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下</span>
          </p>
          <p>
            <span class="quotation">2.</span><span>基于合理需求的披露：运行和维护产品的安全，包括防止或阻止攻击我们的计算机系统或网络；</span>
          </p>
          <p>
            <span class="quotation">3.</span><span>查找、预防或处理欺诈方面的问题；</span>
          </p>
          <p>
            <span class="quotation">4.</span><span>在法律要求或允许的范围内，保护我们、用户或公众的合法权益免遭损害；</span>
          </p>
          <p>
            <span class="quotation">5.</span><span>我们可能会对外公开不含身份识别内容的信息。</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（六）第三方服务、应用</span></strong>
          </p>
          <p>
            <span>为实现本政策中声明的目的及更好的为您提供服务，我们可能会接入第三方服务商提供的SDK或其他类似的应用程序，并将我们依照本政策收集的您的某些信息共享给该等第三方服务商，以便提供更好的客户服务和用户体验。您可以点击<a href="javascript:;" @click="toSDKList" style="color:#e4af09;font-weight: bolder;text-decoration: underline;">《第三方SDK目录》</a>，了解我们主要接入的第三方SDK基本情况，各单项服务接入第三方SDK的情况可能有不同，如需了解具体单项服务接入第三方SDK的详细情况，请您前往对应的服务页面并查阅我们各单项服务的具体条款和相关页面。目前，我们为了实现如下功能或服务接入了第三方服务商：</span>
          </p>
          <p>
            <span><span class="quotation">1. </span><span>产品使用情况分析：为分析我们服务的使用情况，提升用户使用体验，我们会与第三方服务商腾讯bugly共享产品的使用情况（崩溃、闪退、使用时长等）的去标识化或匿名化数据，这些数据难以与其他信息结合识别您的个人身份；</span>
            </span>
          </p>
          <p>
            <span><span class="quotation">2. </span><span>内容分享：在您点击“分享”键将某些新闻内容分享到第三方社交媒体时，我们将通过第三方服务商友盟分享（Umeng Share SDK）完成分享功能。该功能的实现需要收集您的信息（设备信息、应用列表信息、地理位置等）；</span>
            </span>
          </p>
          <p>
            <span><span class="quotation">3. </span><span>第三方登录：在您登录选择第三方腾讯QQ、微信、微博登录场景时，我们将通过第三方服务商友盟完成第三方平台信息获取并完成登录功能。该功能的实现需要收集您的信息（设备信息、应用列表信息等）；</span>
            </span>
          </p>
          <p>
            <span><span class="quotation">4. </span><span>地理位置定位：在您获取定位位置的天气情况和选择报料勾选上传地理位置场景时，我们将通过第三方服务商百度地图完成定位你的地理位置功能。该功能的实现需要收集您的信息（设备信息、所在地理位置信息等）。</span>
            </span>
          </p>
          <p>
            <span><span class="quotation">5. </span><span>Quick Tracking SDK： Quick Tracking SDK需要收集您的OAID/GAID/MAC/IMEI/Android ID/IDFA/IDFV/OPENUDID/GUID/SIM卡 IMSI 信息/硬件序列号/MCC（移动国家编码）、MNC（移动网号）以提供统计分析服务。</span>
            </span>
          </p>
          <div class="sdk_list_box">
            <div class="h2">
              <span>第三方SDK目录：</span>
            </div>
            <div class="h4">
              <span>极光推送 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>第三方主体：深圳市和讯华谷信息技术有限公司</span></p>
              </li>
              <li>
                <p><span>SDK 用途：为 APP 用户提供信息推送服务，应用自启动（用于点击推送通知则可打开app并跳转到App指定页面）</span></p>
              </li>
              <li>
                <p><span>处理个人信息类型：</span></p>
              </li>
              <li>
                <p><span>设备参数及系统信息(设备类型、设备型号、系统版本、及相关硬件信息)：用于识别用户的设备类型、设备型号、系统版本等，确保消息准确下发；</span></p>
              </li>
              <li>
                <p><span>设备标识符（IMEI、IDFA、Android ID、GID、 MAC、OAID、VAID、AAID、IMSI、MEID、UAID、SN、ICCID、SIM信息）：用于识别唯一用户，保证推送的精准送达及推送信息的准确统计；</span></p>
              </li>
              <li>
                <p><span>网络信息(IP 地址、WiFi 信息、基站信息、DNS地址、DHCP地址、SSID、BSSID)与位置信息（经纬度）：用于优化SDK与极光服务器的网络连接请求，保证服务的稳定性和连续性，同时实现区域推送功能；</span></p>
              </li>
              <li>
                <p><span>应用列表信息(应用崩溃信息、通知开关状态、APP 应用列表及活跃状态、APP 应用页面信息、APP 功能事件相关信息)：当一个设备有多个 APP 的推送链路同时活跃时，我们采用合并链路技术，随机合并成一条链路，以达到为用户节省电省流量的目的；</span></p>
              </li>
              <li>
                <p><span>推送日志信息：以便开发者查询使用推送服务记录，了解推送信息送达的情况，调整推送策略。</span></p>
              </li>
              <li>
                <p><span>数据处理方式：通过去标识化、加密传输及其他安全方式</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://www.jiguang.cn/push">https://www.jiguang.cn/push</a></span>
                </p>
              </li>
              <li>
                <p>
                  <span>隐私政策链接：<a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>小米推送 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>涉及的个人信息类型：设备标识符（如 Android ID、OAID、GAID）、设备信息</span></p>
              </li>
              <li>
                <p><span>使用目的：推送消息，应用自启动（用于点击推送通知则可打开app并跳转到App指定页面）</span></p>
              </li>
              <li>
                <p><span>使用场景：在小米手机终端推送消息时使用</span></p>
              </li>
              <li>
                <p><span>第三方主体：北京小米移动软件有限公司</span></p>
              </li>
              <li>
                <p><span>数据处理方式：通过去标识化、加密传输及其他安全方式</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://dev.mi.com/console/appservice/push.html">https://dev.mi.com/console/appservice/push.html</a></span>
                </p>
              </li>
              <li>
                <p>
                  <span>隐私政策：<a href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>华为推送 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>涉及的个人信息类型：应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息</span></p>
              </li>
              <li>
                <p><span>使用目的：推送消息，应用自启动（用于点击推送通知则可打开app并跳转到App指定页面）</span></p>
              </li>
              <li>
                <p><span>使用场景：在华为手机终端推送消息时使用</span></p>
              </li>
              <li>
                <p><span>第三方主体：华为软件技术有限公司</span></p>
              </li>
              <li>
                <p><span>数据处理方式：通过去标识化、加密传输及其他安全方式</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://developer.huawei.com/consumer/cn/">https://developer.huawei.com/consumer/cn/</a></span>
                </p>
              </li>
              <li>
                <p>
                  <span>隐私政策：<a href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177">https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>OPPO推送SDK</span>
            </div>
            <ul>
              <li>
                <p><span>涉及的个人信息类型：设备标识符（如 IMEI、ICCID、IMSI、Android ID、GAID）、应用信息（如应用包名、版本号和运行状态）、网络信息（如 IP 或域名连接结果，当前网络类型）</span></p>
              </li>
              <li>
                <p><span>使用目的：推送消息</span></p>
              </li>
              <li>
                <p><span>使用场景：在 OPPO 手机终端推送消息时使用</span></p>
              </li>
              <li>
                <p><span>第三方主体：广东欢太科技有限公司</span></p>
              </li>
              <li>
                <p><span>数据处理方式：通过加密传输和处理的安全处理方式</span></p>
              </li>
              <li>
                <p><span>官网链接：<a href="https://open.oppomobile.com/new/introduction?page_name=oppopush">https://open.oppomobile.com/new/introduction?page_name=oppopush</a></span></p>
              </li>
              <li>
                <p><span>隐私政策：<a href="https://open.oppomobile.com/wiki/doc#id=10288">https://open.oppomobile.com/wiki/doc#id=10288</a></span></p>
              </li>
            </ul>
            <div class="h4">
              <span>vivo推送SDK</span>
            </div>
            <ul>
              <li>
                <p><span>涉及的个人信息类型：设备信息</span></p>
              </li>
              <li>
                <p><span>使用目的：推送消息</span></p>
              </li>
              <li>
                <p><span>使用场景：在 vivo 手机终端推送消息时使用</span></p>
              </li>
              <li>
                <p><span>第三方主体：广东天宸网络科技有限公司及将来受让运营 vivo 开放平台的公司</span></p>
              </li>
              <li>
                <p><span>数据处理方式：通过去标识化、加密传输及其他安全方式</span></p>
              </li>
              <li>
                <p><span>官网链接：<a href="https://dev.vivo.com.cn/promote/pushNews">https://dev.vivo.com.cn/promote/pushNews</a></span></p>
              </li>
              <li>
                <p><span>隐私政策：<a href="https://www.vivo.com.cn/about-vivo/privacy-policy">https://www.vivo.com.cn/about-vivo/privacy-policy</a></span></p>
              </li>
            </ul>
            <div class="h4">
              <span>魅族推送SDK</span>
            </div>
            <ul>
              <li>
                <p><span>涉及的个人信息类型：设备标识信息、位置信息、网络状态信息、运营商信息</span></p>
              </li>
              <li>
                <p><span>使用目的：推送消息</span></p>
              </li>
              <li>
                <p><span>使用场景：在魅族手机终端推送消息时使用</span></p>
              </li>
              <li>
                <p><span>第三方主体：珠海市魅族通讯设备有限公司</span></p>
              </li>
              <li>
                <p><span>数据处理方式：通过去标识化、加密传输及其他安全方式</span></p>
              </li>
              <li>
                <p><span>官网链接：<a href="https://open.flyme.cn/service?type=push">https://open.flyme.cn/service?type=push</a></span></p>
              </li>
              <li>
                <p><span>隐私政策：<a href="https://www.meizu.com/legal.html">https://www.meizu.com/legal.html</a></span></p>
              </li>
            </ul>
            <div class="h4">
              <span>极光安全认证 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>第三方主体：深圳市和讯华谷信息技术有限公司</span></p>
              </li>
              <li>
                <p><span>使用目的：为APP 用户提供一键登录、号码验证、安全校验服务</span></p>
              </li>
              <li>
                <p><span>涉及的个人信息类型：设备标识符（包括IMEI、IDFA、Android ID、GAID、MAC、OAID、IMSI、MEID、UAID、ICCID ）、设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称）、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、运营商名称、基站信息、IP地址、WiFi信息、SSID、BSSID）、精确位置信息、软件列表信息（包括软件列表及软件运行列表信息）。</span></p>
              </li>
              <li>
                <p><span>数据处理方式：通过去标识化、加密传输及其他安全方式</span></p>
              </li>
              <li>
                <p><span>隐私政策链接：<a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a></span></p>
              </li>
              <li>
                <p><span>官网链接：<a href="https://www.jiguang.cn">https://www.jiguang.cn</a></span></p>
              </li>
            </ul>
            <div class="h4">
              <span>中国移动认证</span>
            </div>
            <ul>
              <li>
                <p><span>涉及的个人信息类型：网络类型、网络地址、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商</span></p>
              </li>
              <li>
                <p><span>使用目的：识别⽤户的⼿机号码快速登录/号码校验，问题查询、分析、风险控制</span></p>
              </li>
              <li>
                <p><span>数据处理方式：SDK自行采集</span></p>
              </li>
              <li>
                <p><span>第三方主体：中移互联网有限公司</span></p>
              </li>
              <li>
                <p><span>隐私政策链接：<a href="https://wap.cmpassport.com/resources/html/contract2.html">https://wap.cmpassport.com/resources/html/contract2.html</a></span></p>
              </li>
            </ul>
            <div class="h4">
              <span>中国联通认证</span>
            </div>
            <ul>
              <li>
                <p><span>涉及的个人信息类型：网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商</span></p>
              </li>
              <li>
                <p><span>使用目的：识别⽤户的⼿机号码快速登录/业务风控</span></p>
              </li>
              <li>
                <p><span>数据处理方式：SDK自行采集</span></p>
              </li>
              <li>
                <p><span>第三方主体：中国联合网络通信有限公司</span></p>
              </li>
              <li>
                <p><span>隐私政策链接：<a href="https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true">https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true</a></span></p>
              </li>
            </ul>
            <div class="h4">
              <span>中国电信认证</span>
            </div>
            <ul>
              <li>
                <p><span>涉及的个人信息类型：国际移动用户标识码、应用进程信息、ANDROID_ID（可选，V3.8.10以上版本去除）、注册手机号码、本机号码、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本</span></p>
              </li>
              <li>
                <p><span>使用目的：识别⽤户的⼿机号码快速登录/号码校验及业务风控</span></p>
              </li>
              <li>
                <p><span>数据处理方式：SDK自行采集</span></p>
              </li>
              <li>
                <p><span>第三方主体：天翼数字生活科技有限公司</span></p>
              </li>
              <li>
                <p><span>隐私政策链接：<a href="https://e.189.cn/sdk/agreement/show.do?order=2&type=main&appKey=&hidetop=&isShowPre=&returnUrl=https%3A%2F%2Fe.189.cn">https://e.189.cn/sdk/agreement/show.do?order=2&type=main&appKey=&hidetop=&isShowPre=&returnUrl=https%3A%2F%2Fe.189.cn</a></span></p>
              </li>
            </ul>
            <div class="h4">
              <span>火山引擎API</span>
            </div>
            <ul>
              <li>
                <p><span>涉及的个人信息类型：手机号码、IP</span></p>
              </li>
              <li>
                <p><span>使用目的：提供终端用户风险识别服务</span></p>
              </li>
              <li>
                <p><span>第三方主体：北京火山引擎科技有限公司</span></p>
              </li>
              <li>
                <p><span>数据处理方式：API接口</span></p>
              </li>
              <li>
                <p><span>隐私政策链接：<a href="https://www.volcengine.com/docs/6504/166009">https://www.volcengine.com/docs/6504/166009</a></span></p>
              </li>
            </ul>
            <div class="h4">
              <span>友盟统计 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：进行APP运营统计与分析</span></p>
              </li>
              <li>
                <p><span>收集信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://www.umeng.com/analytics">https://www.umeng.com/analytics</a></span>
                </p>
              </li>
              <li>
                <p><span>运营方：友盟同欣（北京）科技有限公司</span></p>
              </li>
              <li>
                <p><span>隐私权政策链接：<a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a></span></p>
              </li>
            </ul>
            <div class="h4">
              <span>Quick Tracking SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：进行APP运营统计与分析</span></p>
              </li>
              <li>
                <p><span>收集个人信息类型：OAID/GAID/MAC/IMEI/Android ID/IDFA/IDFV/OPENUDID/GUID/SIM卡 IMSI 信息/硬件序列号/MCC（移动国家编码）、MNC（移动网号）</span></p>
              </li>
            </ul>
            <div class="h4">
              <span>百度地图 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：用户添加定位栏目、用户发表信息时显示所在位置</span></p>
              </li>
              <li>
                <p><span>收集数据类型：设备信息【包括设备标识信息（Android ID、IDFA、IDFV）、系统信息（操作系统版本、设备品牌及型号、设备配置）和应用信息（应用名）】、 位置信息【可能包括经纬度、GNSS信息、WiFi网关地址、WiFi MAC地址、WiFi信号强度、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）】、 网络类型【如移动网络、WiFi网络】</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://lbsyun.baidu.com/">https://lbsyun.baidu.com/</a></span>
                </p>
              </li>
              <li>
                <p>
                  <span>隐私政策：<a href="https://lbs.baidu.c om/index.php?title=openprivacy">https://lbs.baidu.c om/index.php?title=openprivacy</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>空间视创SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：用于数据监测提供统计分析服务</span></p>
              </li>
              <li>
                <p><span>收集数据类型：设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID/IP地址/SIM卡/IMSI信息），常用设备信息（软件安装列表，手机型号、手机品牌、Android系统版本、Android系统api等级、厂商系统版本），网络信息，存储权限</span></p>
              </li>
            </ul>
            <div class="h4">
              <span>七牛云对象存储 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：用户上传图片视频</span></p>
              </li>
              <li>
                <p><span>数据类型：设备识别信息、图片或视频文件</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://www.qiniu.com/products/kodo">https://www.qiniu.com/products/kodo</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>穿山甲SDK（com.bytedance.sdk）</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：广告</span></p>
              </li>
              <li>
                <p><span>数据类型：获取网络状态、访问Wi-Fi状态、位置信息、读写外置存储器、读取手机状态和身份</span></p>
              </li>
              <li>
                <p>
                  <span>SDK隐私政策链接：<a href="https://www.pangle.cn/privacy/partner">https://www.pangle.cn/privacy/partner</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>阿里云快速接口解析 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：解析接口数据渲染页面</span></p>
              </li>
              <li>
                <p><span>收集信息类型：设备信息（IMEI，IMSI）,唯一设备识别码(android_id,bssid)</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://github.com/alibaba/fastjson">https://github.com/alibaba/fastjson</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>阿里路由 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：解析接口数据渲染页面</span></p>
              </li>
              <li>
                <p><span>收集信息类型：设备信息（IMEI，IMSI）,唯一设备识别码(android_id,bssid)</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://github.com/alibaba/ARouter/tree/master">https://github.com/alibaba/ARouter/tree/master</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>腾讯TBS浏览服务</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：提高新闻页webview的用户浏览体验</span></p>
              </li>
              <li>
                <p><span>收集信息类型：设备信息（ssid(SSID)，国际移动设备识别码（IMEI、IMSI），任务列表(任务列表)，Wifi信息(Wifi信息)，国际移动用户识别码（IMSI），MAC地址(MAC地址)、唯一设备识别码(android_id,bssid)，SIM卡信息(iccid)，设备类型(手机样式,网络设备制造商,手机名)，用户机型、屏幕尺寸、操作系统版本号、目标API（targetAPI）、网络类型(ApnType)、网络变化监听广播，存储设备。</span></p>
              </li>
              <li>
                <p><span>调用的权限：读取手机状态和身份,读取电话状态</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://x5.tencent.com/tbs/guide/sdkInit.html">https://x5.tencent.com/tbs/guide/sdkInit.html</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>腾讯bugly</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：统计应用的崩溃信息日志</span></p>
              </li>
              <li>
                <p><span>数据类型：设备识别信息</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://bugly.qq.com/v2/">https://bugly.qq.com/v2/</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>微信 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：用户进行第三方账号登录以及分享内容到第三方平台</span></p>
              </li>
              <li>
                <p><span>数据类型：设备信息</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://open.weixin.qq.com/">https://open.weixin.qq.com/</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>微博 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：用户进行第三方账号登录以及分享内容到第三方平台</span></p>
              </li>
              <li>
                <p><span>数据类型：设备信息</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://open.weibo.com/development/mobile">https://open.weibo.com/development/mobile</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>QQ SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：用户进行第三方账号登录以及分享内容到第三方平台</span></p>
              </li>
              <li>
                <p><span>数据类型：设备信息</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://open.tencent.com/">https://open.tencent.com/</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>友盟社会化分享 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：一键分享到QQ，朋友圈，微信，微博的合集</span></p>
              </li>
              <li>
                <p><span>收集信息类型：位置信息，系统日志，存储设备，设备信息（IMEI，MAC地址(MAC地址)，手机序列号，系统版本(设备版本)，蓝牙Mac，BSSID、ssid(ssid)、唯一设备识别码（IMEI/androidID/IDFA/OPENUDID/GUID、SIM 卡IMSI信息），CPU信息）、任务列表(任务列表)、WIFI信息，唯一设备识别码(android_id,bssid)，设备类型(设备型号)</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://www.umeng.com/social/">https://www.umeng.com/social/</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>百度智能云播放器 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：帮助开发者在 Android 移动设备上实现媒体播放功能</span></p>
              </li>
              <li>
                <p><span>数据类型：设备内音频或视频文件</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://cloud.baidu.com/product/mct.html/">https://cloud.baidu.com/product/mct.html/</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>神策分析 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>第三方名称：神策网络科技（北京）有限公司</span></p>
              </li>
              <li>
                <p><span>使用目的：收集用户基础数据并给用户建模，为用户生成个性化内容</span></p>
              </li>
              <li>
                <p><span>收集信息类型：设备信息（包括IMEI、Android ID、IDFA、IDFV、OAID、UUID、Mac地址、IMSI信息等）、日志信息（包括IP地址、访问服务的URL、浏览器类型和使用语言等）、位置信息、唯一应用程序编号。</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://www.sensorsdata.cn/">https://www.sensorsdata.cn/</a></span>
                </p>
              </li>
            </ul>
            <div class="h4">
              <span>讯飞 SDK</span>
            </div>
            <ul>
              <li>
                <p><span>使用目的：语音合成</span></p>
              </li>
              <li>
                <p><span>收集信息范围：设备号（IMEI号）、设备码（IMSI码）、IP地址、Android ID（安卓唯一设备ID以提供能力授权服务）、中国移动UAID（仅限安卓设备）、OAID（仅限安卓设备）、UUID（仅限iOS设备）、mac地址（仅限Linux设备）</span></p>
              </li>
              <li>
                <p>
                  <span>官网链接：<a href="https://www.xfyun.cn/">https://www.xfyun.cn/</a></span>
                </p>
              </li>
            </ul>
          </div>
          <p>
            <span>我们仅会出于正当、必要、特定的目的共享您的信息。仅将去标识化或匿名化处理后的信息共享给第三方。对我们与之共享信息的第三方服务商，我们会要求他们履行相关保密义务并采取相应的安全措施及提供相关安全等级认证。如果您有需要了解的，您也可以选择通过本政策“联系我们”章节所列的反馈渠道联系我们，我们会尽快为您作出解答。</span>
          </p>
          <p>
            <span>本政策仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。该等第三方服务由相关的第三方负责运营。您使用该等第三方服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本政策）约束，您需要仔细阅读其条款。如您发现这些第三方服务存在风险时，建议您终止相关操作以保护您的合法权益。</span>
          </p>
        </div>
        <div class="h4">
          <span>四、我们如何使用</span><span class="quotation"> Cookie </span><span>和同类技术</span>
        </div>
        <div class="block_box">
          <p>
            <span>为确保网站正常运转，我们会在您的计算机或移动设备上存储名为</span><span class="quotation"> Cookie </span><span>的小数据文件。</span><span class="quotation">Cookie </span><span>通常包含标识符、站点名称以及一些号码和字符。借助于</span><span class="quotation"> Cookie</span><span>，网站能够存储您的偏好数据。</span>
          </p>
          <p>
            <span>我们不会将</span><span class="quotation"> Cookie </span><span>用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除</span><span class="quotation"> Cookie</span><span>。您可以清除计算机上保存的所有</span><span class="quotation"> Cookie</span><span>，大部分网络浏览器都设有阻止</span><span class="quotation"> Cookie </span><span>的功能，您可以在浏览器设置功能或用户选择机制中进行修改。但如果您这么做，则可能需要在每一次访问我们的网站时亲自更改用户设置。</span>
          </p>
        </div>
        <div class="h4">
          <span>五、</span> <span>您的权利</span>
        </div>
        <div class="block_box">
          <p>
            <span>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（一）访问您的个人信息</span></strong>
          </p>
          <p>
            <span>您有权访问您向我们提交的个人信息，除法律法规规定的例外情况除外。如果您希望访问或编辑您的帐户中的个人资料信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过登录您的帐户在个人中心中执行此类操作。</span>
          </p>
          <p>
            <span>如果您无法通过上述方法管理个人信息，您可以发送电子邮件至【</span><span class="quotation">ctdsbwz@163.com</span><span>】。</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（二）更正您的个人信息</span></strong>
          </p>
          <p>
            <span>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过</span><span class="quotation">“</span><span>（一）访问您的个人信息</span><span class="quotation">”</span><span>中罗列的方式提出更正申请。</span>
          </p>
          <p>
            <span>如果您无法通过上述方法更正这些个人信息，您可以发送电子邮件至【</span><span class="quotation">ctdsbwz@163.com</span><span>】。</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（三）删除您的个人信息</span></strong>
          </p>
          <p>
            <span>在以下情形中，您可以向我们提出删除个人信息的请求：</span>
          </p>
          <p>
            <span class="quotation">1. </span><span>如果我们处理个人信息的行为违反法律法规；</span>
          </p>
          <p>
            <span class="quotation">2. </span><span>如果我们收集、使用您的个人信息，却未征得您的同意；</span>
          </p>
          <p>
            <span class="quotation">3. </span><span>如果我们处理个人信息的行为违反了与您的约定；</span>
          </p>
          <p>
            <span class="quotation">4. </span><span>个人信息已达您与我们约定的存储期限；</span>
          </p>
          <p>
            <span class="quotation">5. </span><span>如果我们不再为您提供产品和服务。</span>
          </p>
          <p>
            <span>您可以发送电子邮件至【</span><span class="quotation">ctdsbwz@163.com</span><span>】。</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（四）改变您授权同意的范围</span></strong>
          </p>
          <p>
            <span>您可以随时给予或收回您的授权同意。当您收回同意后，我们将不再处理您的相应个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</span>
          </p>
          <p>
            <span>如果您收回您的授权同意，包括不想接受我们给您发送的商业推广，您随时可通过以下方式取消：【</span><span class="quotation">ctdsbwz@163.com</span><span>】</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（五）个人信息主体注销账户</span></strong><strong><span class="quotation">&nbsp;</span></strong><span>您随时可注销此前注册的账户，您可以自行操作，如果无法实现，您可发邮件至【</span><span class="quotation">ctdsbwz@163.com</span><span>】。收到邮件后15个工作日内完成核查和处理。</span>
          </p>
          <p>
            <span>在注销账户之后，我们将不再处理相应的个人信息，并停止为您提供产品和服务。</span>
          </p>
          <p style="text-align:left;text-indent:0;">
            <strong><span>（六）响应您的上述请求</span></strong>
          </p>
          <p>
            <span>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</span>
          </p>
        </div>
        <div class="h4">
          <span>六、</span> <span>我们如何保护您的个人信息</span>
        </div>
        <div class="block_box">
          <p>
            <span>（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人数据。</span>
          </p>
          <p>
            <span>（二）<strong>但我们提醒您，互联网并非绝对安全的环境，我们强烈建议您不要电子邮件、即时通讯或其他电子交互类工具发送保密信息或您的敏感个人信息。</strong></span>
          </p>
          <p>
            <span>（三）我们将尽力确保您发送给我们的信息的安全性。<strong>但如果因现有技术水平无法实现控制的原因导致您的信息被非授权访问、披露、篡改、或毁坏，给您的合法权益受损，我们将不承担责任；</strong>如果因我们人为的管理、操作等行为导致您的信息被侵害，我们会根据法律承担相应责任。</span>
          </p>
          <p>
            <span>（四）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议及补救措施等。</span>
          </p>
        </div>
        <div class="h4">
          <span>七、</span> <span>未成年人个人信息保护</span>
        </div>
        <div class="block_box">
          <p>
            <span>我们的网站和服务主要面向成人。<strong>如果没有父母或监护人的同意，儿童不得创建自己的用户账户。</strong></span>
          </p>
          <p>
            <span>对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或披露此信息。</span>
          </p>
          <p>
            <span>尽管当地法律和习俗对儿童的定义不同，但我们将不满</span><span class="quotation"> 14 </span><span>周岁的任何人均视为儿童。</span>
          </p>
          <p>
            <span>如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</span>
          </p>
        </div>
        <div class="h4">
          <span>八、</span> <span>本政策如何更新</span>
        </div>
        <div class="block_box">
          <p>
            <span>我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。<strong>我们会在本页面上发布对隐私权政策所做的任何变更，请您适时查看我们的网站。</strong></span>
          </p>
        </div>
        <div class="h4">
          <span>九、</span> <span>如何联系我们</span>
        </div>
        <div class="block_box">
          <p>
            <span>如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：</span>
          </p>
          <p>
            <span>开发者：湖北楚天都市报传媒有限责任公司</span>
          </p>
          <p>
            <span>电子邮件：【</span><span class="quotation">ctdsbwz@163.com</span><span>】。</span>
          </p>
          <p>
            <span>一般情况下，我们将在十五个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。</span>
          </p>
          <p class="bottom_date">
            <span>湖北楚天都市报传媒有限责任公司</span>
          </p>
          <p class="bottom_date">
            <span>2021年9月6日</span>
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { loadStat } from "@/utils";
export default {
  name: "Private",
  data() {
    return {};
  },
  methods: {
    /* 跳转第三方SDK目录 */
    toSDKList() {
      this.$bridge.callhandler("toSDKList", null, (data) => { });
    },
  },
  created() {
    document.title = "极目新闻客户端及网站隐私政策";
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.private_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .private_box {
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
    * {
      word-break: normal;
      white-space: normal;
      line-height: 1.5em;
    }
    .title_box {
      .h2 {
        padding: 18px 0;
        line-height: 27px;
        text-align: center;
        color: #000;
        font-size: 18px;
        font-weight: bolder;
        span {
          color: #000;
          font-weight: bolder;
        }
      }
      .h3 {
        line-height: 26px;
        color: #000;
        font-size: 16px;
        font-weight: bolder;
        span {
          color: #000;
          font-weight: bolder;
        }
      }
      .h4 {
        line-height: 24px;
        color: #000;
        font-weight: bolder;
        span {
          color: #000;
          font-weight: bolder;
        }
        .en {
          font-family: "Arial", sans-serif;
          color: #000;
        }
      }
    }
    .content_box {
      .h4 {
        margin-top: 15px;
        color: #000;
        span {
          color: #000;
          font-weight: bolder;
        }
      }
      p {
        margin: 5px 0;
        color: #000;
        font-family: "宋体";
        text-indent: 2em;
        text-align: justify;
        * {
          font-family: "宋体";
          text-align: justify;
        }
        .quotation {
          font-family: "Arial", sans-serif;
        }
        &.bottom_date {
          margin: 5px 0;
          text-align: right;
        }
      }
      ul {
        li {
          margin-left: 20px;
          list-style-type: disc;
          p {
            text-indent: 0;
          }
        }
      }
      .sdk_list_box {
        * {
          word-break: break-all;
          white-space: normal;
          line-height: 1.5em;
        }
        .h2 {
          padding-top: 15px;
          font-size: 18px;
          font-weight: bolder;
          color: #000;
        }
        .h4 {
          margin-top: 15px;
          font-size: 16px;
          font-weight: bolder;
        }
        ul {
          li {
            margin-left: 20px;
            list-style-type: disc;
            p {
              color: #000;
              font-size: 16px;
              font-family: "宋体";
              span {
                font-size: 16px;
                font-family: "宋体";
                a {
                  text-decoration: underline;
                  font-family: "宋体";
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>